<template>
    <div class="wrap o-h">
        <div class="hero-title m-0-a" :style="{background:'url('+info.titlePic+');background-size:cover'}">
        </div>
        <div class="tab m-0-a l-index" :style="{background:'url('+info.tabpic+');background-size:cover'}">
            <a href="javascript:;" class="tab-item d-i-b t-a-c" v-for="(item,index) in info.tab" :style="{color:clickTabIndex == index ? info.activeBg : info.normalBg}" @click="heroBoard(item,index)" :key='index'>
                                                                                                                                                                                {{item.title}}
                                                                                                                                                                            </a>
            <transition name="fade">
                <div v-show='showHeroTab' class="country-board p-r">
                    <a href="javascript:;" class='country-board-item d-i-b t-a-c' v-for="(v,i) in iconList" :key='i' @click='showHero(i)' :style="{color:info.general_color,width:100 / info.length + '%'}">
                                                                                                                                                                                    {{v.name}}
                                                                                                                                                                                </a>
                </div>
            </transition>
        </div>
        <div class="hero m-0-a p-r t-a-c">
            <a href="javascript:;" class="hero-prev p-a" @click="prev" :style="{background:'url('+info.ctrl.prev+');background-size:cover'}"></a>
            <a href="javascript:;" class="hero-next p-a" @click="next" :style="{background:'url('+info.ctrl.next+');background-size:cover'}"></a>
            <img class="hero-content d-i-b" draggable="false" :src="icon" alt="">
        </div>
    </div>
</template>
<style lang="less" scoped>
    .rem10() {
        width: 10rem;
    }
    .wrap {
        width: 100%
    }
    .tab {
        .rem10;
        height: 1.226667rem;
        .tab-item {
            width: 10/5rem;
            line-height: 1.226667rem;
            font-size: .4rem;
        }
    }
    .hero-title {
        width: 6.666667rem;
        height: .826667rem;
        margin-top: .32rem;
        margin-bottom: .373333rem;
    }
    .country-board {
        .rem10;
        background: rgba(0, 0, 0, 0.9);
        z-index: 999;
        .country-board-item {
            width: 25%;
            height: .906667rem;
            font-size: .266667rem; // color: #a99877;
            line-height: 0.90667rem;
        }
    }
    .hero {
        width: 9.6rem;
        .hero-name-tag {
            width: 2.933333rem;
            height: .773333rem;
            right: .48rem;
            bottom: .346667rem
        }
        .hero-prev {
            width: 1.066667rem;
            height: 1.066667rem;
            margin-top: -0.533333rem;
            top: 20%;
            left: 0;
        }
        .hero-next {
            width: 1.066667rem;
            height: 1.066667rem;
            margin-top: -0.533333rem;
            top: 20%;
            right: 0;
        }
    }
</style>
<script>
    export default {
        props: ['info'],
        data() {
            return {
                showHeroTab: false,
                iconList: [], //一整个国家的武将图片数组
                icon: '',
                i: 0, //当前显示的武将索引
                clickTabIndex: 0, //武将tab点击索引
            }
        },
        mounted() {
            this.iconList = this.info.tab[0].picList;
            this.icon = this.iconList[0].url;
        },
        methods: {
            heroBoard(_item, _index) {
                if (this.clickTabIndex == _index) {
                    this.showHeroTab = !this.showHeroTab;
                } else {
                    this.clickTabIndex = _index
                    this.iconList = _item.picList;
                    this.showHeroTab = true;
                }
            },
            showHero(_index) {
                this.i = _index;
                this.showHeroTab = !this.showHeroTab;
                this.icon = this.iconList[_index].url;
            },
            prev() {
                if (this.i > 0) {
                    this.i--;
                    this.icon = this.iconList[this.i].url;
                }
            },
            next() {
                if (this.i < this.iconList.length - 1) {
                    this.i++;
                    this.icon = this.iconList[this.i].url;
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/components/hero/heroes-tab.vue